import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import useLenis, { scrollToId } from "@/hooks/useLenis";
import { CONTENT } from "@/i18n";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/components/HomePage";
import MenuPage from "@/components/MenuPage";
import ServiceMenuPage from "@/components/ServiceMenuPage";
import CateringPage from "@/components/CateringPage";
import StoryPage from "@/components/StoryPage";
import ContactPage from "@/components/ContactPage";

const ScrollManager = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      window.history.replaceState({}, "");
      const timer = setTimeout(() => scrollToId(id), 400);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [location]);
  return null;
};

function App() {
  const [lang, setLang] = useState("en");
  const t = CONTENT[lang];
  useLenis();

  return (
    <div className="min-h-screen bg-cream text-ink" data-testid="app-root">
      <Toaster position="bottom-right" toastOptions={{ style: { background: "#0E1F1B", border: "none", color: "#FBF6EC" } }} />
      <BrowserRouter>
        <ScrollManager />
        <Header t={t} lang={lang} setLang={setLang} />
        <Routes>
          <Route path="/" element={<HomePage t={t} lang={lang} />} />
          <Route path="/menu" element={<MenuPage t={t} lang={lang} />} />
          <Route path="/breakfast" element={<ServiceMenuPage t={t} lang={lang} kind="breakfast" />} />
          <Route path="/lunch" element={<ServiceMenuPage t={t} lang={lang} kind="lunch" />} />
          <Route path="/sweets" element={<ServiceMenuPage t={t} lang={lang} kind="sweets" />} />
          <Route path="/catering" element={<CateringPage t={t} lang={lang} />} />
          <Route path="/story" element={<StoryPage t={t} lang={lang} />} />
          <Route path="/contact" element={<ContactPage t={t} lang={lang} />} />
        </Routes>
        <Footer t={t} />
      </BrowserRouter>
    </div>
  );
}

export default App;
